export type MainHeaderActionId =
    | "notifications"
    | "feedback"
    | "settings"
    | "profile";

export interface MainHeaderAction {
    id: MainHeaderActionId;
    label: string;
    tooltip: string;
    icon: string;
}

export const fetchMainHeaderActions = async (): Promise<MainHeaderAction[]> => {
    return [
        {
            id: "notifications",
            label: "Notifications",
            tooltip: "Notifications",
            icon: "notifications",
        },
        {
            id: "feedback",
            label: "Feedback",
            tooltip: "Give feedback",
            icon: "thumbs_up_down",
        },
        {
            id: "settings",
            label: "Settings",
            tooltip: "Settings",
            icon: "settings",
        },
        {
            id: "profile",
            label: "Profile",
            tooltip: "Profile menu",
            icon: "profile",
        },
    ];
};